import React from 'react';
import { useParams } from 'react-router-dom';
import ContentLayout from 'src/components/ContentLayout';
import OrganizationContextProvider from './OrganizationContextProvider';
import OrganizationShowcase from './OrganizationShowcase';
import OrganizationsList from './OrganizationsList';

const Agent: React.FC = () => {
  const params = useParams();
  
  return (
    <OrganizationContextProvider>
      <ContentLayout
        size="fullScreen"
        sidebar={<OrganizationsList />}
        content={(
          // При помощи key для каждой организации создаётся своя витрина со своим жизненным циклом, хуками, стейтом и тд.
          // https://beta.reactjs.org/learn/preserving-and-resetting-state#option-2-resetting-state-with-a-key
          <OrganizationShowcase key={params.organizationUeid} />
        )}
      />
    </OrganizationContextProvider>
  );
};

export default Agent;
